<template>

  <div>
    <div
      class="btn-group btn-group-sm"
      role="group">
      <button
        v-if="hasRequired"
        type="button"
        class="btn"
        @click="setValue('required')"
        :class="value[type] === 'required' ? 'btn-success' : 'btn-light'">{{ $t('Required') }}</button>
      <button
        type="button"
        class="btn"
        @click="setValue('optional')"
        :class="value[type] === 'optional' ? 'btn-warning' : 'btn-light'">{{ $t('Optional') }}</button>
      <button
        type="button"
        class="btn"
        @click="setValue('hidden')"
        :class="value[type] === 'hidden' ? 'btn-danger' : 'btn-light'">{{ $t('Disabled') }}</button>
    </div>
  </div>

</template>

<script>
export default {
  name: 'AccountApplyfieldsSelect',
  props: {
    value: {
      type: Object
    },
    type: {
      type: String
    },
    hasRequired: {
      type: Boolean
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  computed: {
  },
  methods: {
    setValue (val) {
      this.$emit('input', {
        ...this.value,
        [this.type]: val
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Account/AccountApplyfieldsSelect.vue